module.exports = __webpack_public_path__ + "static/media/partnerships-growth-first.caae8d06.jpg";